import React from 'react';
import './profilesetting.css';
import BreadCrum from '../features/breadcrum/BreadCrum';
import PersonalInfo from './profile-settings/PersonalInfo';
import PaymentMethods from './profile-settings/PaymentMethods';
import { DeleteSvg } from './profile-settings/svgs';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import {
    getCustomerDetails,
    setUser,
    updateCustomerPersonalInfo,
    updateUserStatus,
} from '../redux/users/actionCreator';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { Button, Modal, Spin } from 'antd';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { destroySession } from '../helpers/functions';
import { persistor } from '../redux/store';
import { handleLogout } from '../redux/authentication/actionCreator';
import { toast } from 'react-toastify';

const Profilesetting = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const { userData, isLoading, isCardLoading } = useSelector(
        (state) => state.user
    );

    const [messageNotifications, setMessageNotifications] = useState(true);
    const [emailNotifications, setEmailNotifications] = useState(true);
    const [loadingButton, setLoadingButton] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [pendingNotificationUpdate, setPendingNotificationUpdate] = useState(null);

    const updateNotificationsSetting = (name, checked) => {
        setLoadingButton(name);
        let formData = new FormData();
        let id = userData?.id;
        let message = 'Notifications setting updated successfully';
        formData.append(name, checked);
        dispatch(
            updateCustomerPersonalInfo(id, formData, message, () => {
                setLoadingButton('');
            })
        );
    };

    const handleChange = (e) => {
        let { name, checked } = e.target;
        if (!checked) {
            setPendingNotificationUpdate({ name, checked });
            setIsOpen(true);
        } else {
            updateNotificationsSetting(name, true);
        }
    };

    const handleConfirmDisable = () => {
        if (pendingNotificationUpdate) {
            updateNotificationsSetting(
                pendingNotificationUpdate.name,
                pendingNotificationUpdate.checked
            );
            setPendingNotificationUpdate(null);
        }
        setIsOpen(false);
    };

    const handleCancelDisable = () => {
        setPendingNotificationUpdate(null);
        setIsOpen(false);
    };

    const SignOut = async () => {
        setUser(null);
        destroySession();
        await persistor.purge();
        dispatch(handleLogout());
        history.push('/register');
    };

    useEffect(() => {
        if (userData) {
            setMessageNotifications(
                Boolean(userData?.text_message_notifications)
            );
            setEmailNotifications(
                Boolean(userData?.email_marketing_notifications)
            );
        }
    }, [userData]);

    useEffect(() => {
        dispatch(getCustomerDetails());
    }, []);
    return (
        <>
            <div className="container mt-3">
                <BreadCrum
                    items={[
                        { title: 'Home', path: '/home' },
                        {
                            title: 'My Profile',
                            path: '/customer/profile-setting',
                        },
                    ]}
                />
            </div>
            <div className="container profilecontainer gap-4 my-5">
                <PersonalInfo />
                <div className="col-12 col-md-8 poppins">
                    {/* Card 1: Payment Methods */}
                    <div 
                        className="border p-4 mb-4 bg-white" 
                        style={{ 
                            borderRadius: '16px', 
                            borderColor: '#e4e7ec',
                            boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.05), 0px 1px 2px rgba(16, 24, 40, 0.03)'
                        }}
                    >
                        <PaymentMethods />
                    </div>

                    {/* Card 2: Notifications & Account Status */}
                    <div 
                        className="border p-4 mb-4 bg-white" 
                        style={{ 
                            borderRadius: '16px', 
                            borderColor: '#e4e7ec',
                            boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.05), 0px 1px 2px rgba(16, 24, 40, 0.03)'
                        }}
                    >
                        <div className="pb-3" style={{ borderBottom: '1px solid #f2f4f7' }}>
                            <p className="c-0f151d poppins f-16 lh-24 fw-semibold mb-1">
                                My Notifications
                            </p>
                            <p className="c-667085 f-14 poppins mb-0">
                                We’ll send you updates about your appointments, news and marketing offers.
                            </p>
                        </div>

                        <div className="d-flex justify-content-between align-items-center gap-3 py-3" style={{ borderBottom: '1px solid #f2f4f7' }}>
                            <div>
                                <p className="c-0f151d poppins f-15 fw-medium mb-1">
                                    Email marketing notifications
                                </p>
                                <p className="c-667085 f-13 poppins mb-0">
                                    Receive offers and news via email
                                </p>
                            </div>
                            <div className="form-check form-switch mb-0">
                                <label className="switch">
                                    <input
                                        name="email_marketing_notifications"
                                        type="checkbox"
                                        checked={emailNotifications}
                                        onChange={handleChange}
                                    />
                                    {isLoading &&
                                        loadingButton ===
                                        'email_marketing_notifications' ? (
                                        <Spin />
                                    ) : (
                                        <span className="slider"></span>
                                    )}
                                </label>
                            </div>
                        </div>

                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3 pt-3">
                            <div>
                                <p className="c-0f151d poppins fw-semibold f-15 mb-0">
                                    {userData?.status === 'active'
                                        ? 'Deactivate account'
                                        : 'Activate account'}
                                </p>
                            </div>
                            <button
                                type="button"
                                className="d-flex align-items-center gap-2 border-0 bg-transparent text-danger fw-semibold poppins f-14 p-0"
                                style={{ cursor: 'pointer' }}
                                onClick={() => setIsDeactivateModalOpen(true)}
                            >
                                {userData?.status === 'active' ? (
                                    <>
                                        <DeleteSvg />
                                        <span>Deactivate my account</span>
                                    </>
                                ) : (
                                    <span className="text-success">Activate my account</span>
                                )}
                            </button>
                        </div>
                    </div>

                    {/* Bottom Action Buttons */}
                    <div className="d-flex flex-column flex-sm-row gap-3 mt-4">
                        <button
                            className="poppins f-15 fw-semibold rounded-3 py-3 border-0 w-100 transition-all text-center"
                            style={{
                                backgroundColor: '#f2f4f7',
                                color: '#344054',
                                cursor: 'pointer'
                            }}
                            onClick={() => history.push('/customer/my-favourites')}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#eaecf0'}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f2f4f7'}
                        >
                            My favorites
                        </button>
                        <button
                            className="poppins f-15 fw-semibold text-white rounded-3 py-3 border-0 w-100 transition-all text-center"
                            style={{
                                backgroundColor: '#2b5c35',
                                cursor: 'pointer'
                            }}
                            onClick={() => setIsModalOpen(true)}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#214729'}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2b5c35'}
                        >
                            List your business
                        </button>
                    </div>
                </div>
            </div>
            <Modal
                open={isOpen}
                onCancel={handleCancelDisable}
                footer={null}
                centered
                bodyStyle={{ padding: '24px 24px 16px 24px' }}
            >
                <div className="text-center py-2">
                    <div 
                        className="d-inline-flex align-items-center justify-content-center mb-3" 
                        style={{ 
                            width: '48px', 
                            height: '48px', 
                            borderRadius: '50%', 
                            backgroundColor: '#fee2e2', 
                            color: '#d92d20' 
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" style={{ width: '24px', height: '24px' }}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m0-10.03A11.95 11.95 0 0112 2.25c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm0 13.5h.01" />
                        </svg>
                    </div>
                    <h4 className="poppins fw-semibold text-dark mb-2" style={{ fontSize: '18px' }}>
                        Disable Notifications?
                    </h4>
                    <p className="poppins text-muted mb-4" style={{ fontSize: '14px', lineHeight: '20px', color: '#475467' }}>
                        You will not receive updates on your appointments booking when you switch it off.
                    </p>
                    <div className="d-flex justify-content-center gap-3">
                        <button
                            className="poppins fw-semibold px-4 py-2 border text-dark transition-all text-center"
                            style={{
                                backgroundColor: '#ffffff',
                                borderColor: '#d0d5dd',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                minWidth: '100px'
                            }}
                            onClick={handleCancelDisable}
                            onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor = '#f9fafb';
                                e.currentTarget.style.borderColor = '#c6c2c2';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor = '#ffffff';
                                e.currentTarget.style.borderColor = '#d0d5dd';
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            className="poppins fw-semibold text-white px-4 py-2 border-0 transition-all text-center"
                            style={{
                                backgroundColor: '#2b5c35',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                minWidth: '100px'
                            }}
                            onClick={handleConfirmDisable}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#214729'}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2b5c35'}
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
            >
                <h4>Confirmation required</h4>
                <p className="mb-5">
                    Would you like to log out from your customer account and
                    register as a business?
                </p>
                <div className="d-flex gap-3 justify-content-end">
                    <button
                        className="btn btn-outline"
                        onClick={() => setIsModalOpen(false)}
                    >
                        Cancel
                    </button>
                    <button className="btn btn-success" onClick={SignOut}>
                        Proceed
                    </button>
                </div>
            </Modal>
            <Modal
                open={isDeactivateModalOpen}
                onCancel={() => setIsDeactivateModalOpen(false)}
                footer={null}
            >
                <h4>Confirmation required</h4>
                <p className="mb-5">
                    {`Are you sure you want to ${userData?.status === 'active'
                        ? 'deactivate'
                        : 'activate'
                        } your account?`}
                </p>
                <div className="d-flex gap-3 justify-content-end">
                    <button
                        className="btn btn-outline"
                        onClick={() => setIsDeactivateModalOpen(false)}
                    >
                        Cancel
                    </button>
                    <button
                        className={`btn ${userData?.status === 'active'
                            ? 'btn-danger'
                            : 'btn-success'
                            }  `}
                        disabled={isCardLoading}
                        onClick={() => {
                            let status =
                                userData?.status === 'active'
                                    ? 'inactive'
                                    : 'active';
                            dispatch(
                                updateUserStatus(status, () => {
                                    setIsDeactivateModalOpen(false);
                                })
                            );
                        }}
                    >
                        {isCardLoading ? <Spin /> : 'Proceed'}
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default Profilesetting;
